import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateConfig, getLog } from "@/api/configurationlist";
import { cloneDeep, isEqual } from "lodash";
export default {
  props: ["deviceDid", "deviceSn", 'data', 'originalServer', 'nms'],
  data: function data() {
    return {
      //日志优先级选项
      LogPriorityList: [{
        value: '8',
        label: this.$t('lang.smartlink.debug')
      }, {
        value: '7',
        label: this.$t('lang.smartlink.info')
      }, {
        value: '6',
        label: this.$t('lang.smartlink.notice')
      }, {
        value: '5',
        label: this.$t('lang.smartlink.alarm')
      }, {
        value: '4',
        label: this.$t('lang.smartlink.error')
      }, {
        value: '3',
        label: this.$t('lang.smartlink.deadly')
      }, {
        value: '2',
        label: this.$t('lang.smartlink.alert')
      }, {
        value: '1',
        label: this.$t('lang.smartlink.emergency')
      }]
    };
  },
  watch: {
    server: {
      immediate: true,
      handler: function handler() {
        this.data.enabled = this.data.enabled == '1' ? true : false;
        this.data.enable_debug = this.data.enable_debug == '1' ? true : false;
      }
    }
  },
  computed: {
    server: function server() {
      return this.data;
    }
  },
  methods: {
    updateService: function updateService() {
      var _this = this;

      if (!isEqual(this.originalServer, this.data)) {
        var copyData = cloneDeep(this.data);
        copyData.enabled = copyData.enabled == false ? "" : "1";
        copyData.enable_debug = copyData.enable_debug == false ? "" : "1";
        updateConfig(this.deviceSn, this.deviceDid, [{
          section: "service",
          config: this.nms ? "smartnms" : "smartlink",
          action: 0,
          index: [0],
          server: this.nms ? "smartnms" : "smartlink",
          options: _objectSpread({}, copyData)
        }]).then(function (res) {
          if (res.data.data.mess === 0) {
            _this.$message({
              showClose: true,
              message: _this.$t("lang.ConfigSetting.Successfulconfiguration"),
              type: "success"
            });

            _this.$emit("updateData");
          } else {
            _this.$message({
              showClose: true,
              message: _this.$t("lang.ConfigSetting.Configurationerror"),
              type: "warning"
            });

            return;
          }
        }).catch(function (err) {});
      }
    },
    // 下载日志文件
    downloadLog: function downloadLog() {
      var _this2 = this;

      var params = {
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: this.nms ? "smartnms" : "smartlink"
      };
      getLog(params).then(function (res) {
        var data = res.data; // 创建Blob对象（类文件对象）

        var blob = new Blob([data]); // let disposition = decodeURI(res.headers['content-disposition'])
        // 从响应头中获取文件名
        // let filename = disposition.substring(disposition.indexOf('fileName=') + 9, disposition.length)

        if ('download' in document.createElement('a')) {
          // 非IE下载
          // 创建隐藏下载超链接
          var elink = document.createElement('a'); // 使用超链接的download属性下载文件

          elink.download = '日志文件';
          elink.style.display = 'none'; // 使用Blob创建一个指向类型化数组的URL

          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink); // 自定点击超链接

          elink.click(); // 释放URL对象

          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          //IE10+下载
          navigator.msSaveBlob(blob, filename);
        }
      }).catch(function (err) {
        _this2.$message.error(_this2.$t("lang.request.smartlinkError"));
      });
    }
  }
};